import ContactsPage from "./ContactsPage";

const page = ContactsPage;
export default page;
